<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.56863 6.50982L7.07843 9.01963L12.098 4L13.6667 5.56863L7.07843 12.1569L3 8.07845L4.56863 6.50982Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts" setup></script>
